import React from 'react'
import PropTypes from 'prop-types'
import shouldUpdate from 'recompose/shouldUpdate'
import ClassNames from 'classnames'

import FieldTitle from '@/ui/Data/FieldTitle'
import ButtonField from '@/ui/Data/ButtonField'

import ContentSort from '@/icons/Sort'
import HasSort from '@/icons/HasSort'

import { SORT_ASC } from '@/state/types/query'

export const DatagridHeaderCell = ({ field, width, currentSort, updateSort, resource, theme }) => {
  const isSorted = field.props.source === currentSort.field
  return (
    <th
      {...width && {
        style: {
          width: width,
        },
      }}
      className={ClassNames(
        theme[`column-${field.props.source || field.props.cellName || 'simple'}`],
        {
          [theme['sorted']]: isSorted,
        },
      )}
    >
      <Choose>
        <When condition={field.props.sortable !== false && field.props.source}>
          <ButtonField onClick={updateSort} data-sort={field.props.source} theme={theme}>
            <FieldTitle label={field.props.label} source={field.props.source} resource={resource} />
            <Choose>
              <When condition={isSorted}>
                <ContentSort
                  size="1.5em"
                  style={currentSort.order === SORT_ASC ? { transform: 'rotate(180deg)' } : {}}
                />
              </When>
              <Otherwise>
                <HasSort size="1.5em" />
              </Otherwise>
            </Choose>
          </ButtonField>
        </When>
        <Otherwise>
          <FieldTitle label={field.props.label} source={field.props.source} resource={resource} />
        </Otherwise>
      </Choose>
    </th>
  )
}

DatagridHeaderCell.propTypes = {
  field: PropTypes.element,
  theme: PropTypes.object,
  currentSort: PropTypes.shape({
    sort: PropTypes.string,
    order: PropTypes.string,
  }),
  isSorting: PropTypes.bool,
  sortable: PropTypes.bool,
  resource: PropTypes.string,
  updateSort: PropTypes.func.isRequired,
}

export default shouldUpdate(
  (props, nextProps) =>
    props.isSorting !== nextProps.isSorting ||
    (nextProps.isSorting && props.currentSort.order !== nextProps.currentSort.order),
)(DatagridHeaderCell)



// WEBPACK FOOTER //
// ./ui/DataTable/DatagridHeaderCell.js